import { IDocument } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import { BaseService } from '../BaseService';
import toast from 'features/toast';

class FetchDocumentService extends BaseService<IDocument> {
  G4L_file = 'documentsG4File';
  constructor() {
    super('documentsLM');
  }

  protected appendObjectsToFormData(formData: FormData, objects_id: any[], fieldName: string) {
    objects_id.forEach((item) => {
      formData.append(fieldName + 's', item.toString());
    });
  }

  uploadDocument = async (
    tipology: any,
    attachment: File,
    name: string,
    description: string,
    folder: string,
    folder_description: string,
    category?: string,
    supplier?: string,
    warehouse?: string,

    fieldName = '',
    objects_id?: any[]
  ) => {
    const formData = new FormData();
    formData.append('tipology', typeof tipology === 'string' ? tipology : tipology.name);
    formData.append('attachment', attachment);
    formData.append('name', name);
    formData.append('description', description);
    formData.append('category', category);
    formData.append('supplier', supplier ?? '');
    formData.append('warehouse', warehouse ?? '');
    formData.append('folder', '/' + folder);
    formData.append('folder_description', folder_description ?? '');

    if (objects_id && objects_id.length > 0 && fieldName) {
      this.appendObjectsToFormData(formData, objects_id, fieldName);
    }

    const response = await axiosPrivate.post<IDocument>(
      `${this.modulePrefix}/${fieldName}/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response.data;
  };

  uploadMultipleDocuments = async (files: File[]) => {
    const promises = files.map((file) => this.uploadSingleDocument(file));

    // Esegui in parallelo
    return Promise.allSettled(promises);
  };

  uploadSingleDocument = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', file.webkitRelativePath || file.name);

    const response = await axiosPrivate.post<{ task_id: string; file: string }>(
      `${this.modulePrefix}/upload-single/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response.data; // { task_id, file }
  };

  getUploadStatus = async (taskId: string) => {
    try {
      const response = await axiosPrivate.get(`${this.modulePrefix}/upload-status/${taskId}/`);
      return response.data; // { task_id, status, result }
    } catch (error: any) {
      throw new Error(error.message || 'Errore durante il recupero dello stato upload');
    }
  };

  downloadAttachment = async (entityId: number) => {
    axiosPrivate
      .get(`${this.G4L_file}/${entityId}/download-attachment/`, {
        responseType: 'blob'
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition?.indexOf('attachment') !== -1) {
          const filenameMatches = contentDisposition.match(
            /(?:.*filename\*|filename)=(?:([^'"]*)''|("))([^;]+)\2(?:[;`\n]|$)/
          );
          const filename = filenameMatches.pop();
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      });
  };

  getAllPaginatedDocuments = async (
    documentType = '',
    limit = 0,
    offset = 0,
    params: Record<string, unknown> = {}
  ) => {
    try {
      // Aggiunge una barra finale se non è presente
      const url = `${this.modulePrefix}/${documentType}/`.replace(/\/?$/, '/');
      const res = await axiosPrivate.get(url, {
        params: { limit, offset, ...params }
      });
      return res.data;
    } catch (e) {
      toast.error(e.message);
    }
  };

  getAdvancedSearchDocuments = async (
    limit = 0,
    offset = 0,
    params: Record<string, unknown> = {}
  ) => {
    try {
      // Aggiunge una barra finale se non è presente
      const url = `${this.modulePrefix}/advanced-db-search/`.replace(/\/?$/, '/');
      const res = await axiosPrivate.get(url, {
        params: { limit, offset, ...params }
      });
      return res.data;
    } catch (e) {
      toast.error(e.message);
    }
  };
}

export const fmDocumentService = new FetchDocumentService();
